// DEPRECATION WARNING: These are legacy endpoints that will be migrated to the
// new subscription service. See actions/plans.js for the replacement.

import { fetchRequestWithTypes } from './index.js';

export const POST_USER_PLATFORM_TIER_REQUEST = 'POST_USER_PLATFORM_TIER_REQUEST';
export const POST_USER_PLATFORM_TIER_SUCCESS = 'POST_USER_PLATFORM_TIER_SUCCESS';
export const POST_USER_PLATFORM_TIER_ERRORED = 'POST_USER_PLATFORM_TIER_ERRORED';

export const postUserPlatformTier = (tier_type) => {
	return fetchRequestWithTypes({
		types: [
			POST_USER_PLATFORM_TIER_REQUEST,
			POST_USER_PLATFORM_TIER_SUCCESS,
			POST_USER_PLATFORM_TIER_ERRORED,
		],
		request: {
			method: 'POST',
			path: '/api/v1/users/:uuid/platform_tiers/user_platform_tiers',
			body: { tier_type },
		},
	});
};

export const GET_BILLING_PERIODS_REQUEST = 'GET_BILLING_PERIODS_REQUEST';
export const GET_BILLING_PERIODS_SUCCESS = 'GET_BILLING_PERIODS_SUCCESS';
export const GET_BILLING_PERIODS_ERRORED = 'GET_BILLING_PERIODS_ERRORED';

export const getBillingPeriods = () =>
	fetchRequestWithTypes({
		types: [
			GET_BILLING_PERIODS_REQUEST,
			GET_BILLING_PERIODS_SUCCESS,
			GET_BILLING_PERIODS_ERRORED,
		],
		request: {
			method: 'GET',
			path: '/api/v1/users/:uuid/platform_tiers/billing_periods',
		},
	});

export const PATCH_BILLING_PERIOD_REQUEST = 'PATCH_BILLING_PERIOD_REQUEST';
export const PATCH_BILLING_PERIOD_SUCCESS = 'PATCH_BILLING_PERIOD_SUCCESS';
export const PATCH_BILLING_PERIOD_ERRORED = 'PATCH_BILLING_PERIOD_ERRORED';

export const patchBillingPeriod = (billing_period_id) => {
	return fetchRequestWithTypes({
		types: [
			PATCH_BILLING_PERIOD_REQUEST,
			PATCH_BILLING_PERIOD_SUCCESS,
			PATCH_BILLING_PERIOD_ERRORED,
		],
		request: {
			method: 'PATCH',
			path: '/api/v1/users/:uuid/platform_tiers/billing_periods',
			body: { billing_period_id },
		},
	});
};

export const GET_BILLING_SUMMARY_REQUEST = 'GET_BILLING_SUMMARY_REQUEST';
export const GET_BILLING_SUMMARY_SUCCESS = 'GET_BILLING_SUMMARY_SUCCESS';
export const GET_BILLING_SUMMARY_ERRORED = 'GET_BILLING_SUMMARY_ERRORED';

export const getBillingSummary = () => {
	return fetchRequestWithTypes({
		types: [
			GET_BILLING_SUMMARY_REQUEST,
			GET_BILLING_SUMMARY_SUCCESS,
			GET_BILLING_SUMMARY_ERRORED,
		],
		request: {
			method: 'GET',
			path: '/apis/customers/v1/users/:uuid/subscriptions/invoicePreview',
		},
	});
};
